import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SolardashboardService {
 
  constructor(private http: HttpClient) { }

  addupdateSolarManager(data): Observable<any> {
    return this.http.post(`addUpdateSolarManager`,data);
  }
  getSolarMagaer(roleid, userid, module) {
    return this.http.get(`getSolarManagerData?roleid=${roleid}&userid=${userid}&module=${module}`);
 }
 getSolarManagerData(data):Observable<any> {
  return this.http.post(`getSolarManagerData`,data);
}
 deletSolarManager(data):Observable<any> {
  return this.http.delete(`deleteSolarManager`, {
    params: {
      serialNo: data.serialNo,
      deviceId: data.device_id
    }
  });
}
getSolarAssetId(data):Observable<any>{
  return this.http.post(`getSolarAssetId`,data);
}
getGeneration(data):Observable<any>{
  return this.http.post(`getGenerationData`,data);
}
getGenerationPerAsset(data):Observable<any>{
  return this.http.post(`getGenerationPerAsset`,data);
}
generationGraph(data):Observable<any>{
  return this.http.post(`getDailyGeneration`,data);
}
generationGraphWeekly(data):Observable<any>{
  return this.http.post(`getWeeklyGeneration`,data);
}
generationGraphMonthly(data):Observable<any>{
  return this.http.post(`getMonthlyGeneration`,data);
}
getWeatherData(data):Observable<any>{
  return this.http.post(`getWeatherData`,data);
}
getCalenderData(data):Observable<any>{
  return this.http.post(`getCalenderData`,data);
}
getDeviceStatus(data):Observable<any>{
  return this.http.post(`getLastData`,data);
}
}
